import React from 'react';

export default class Page8 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Development action planning</div>
                                            <p>
                                                It’s vital that a plan for someone’s development is written,
                                                because it clearly explains what is
                                                intended to all involved, and achieves greater commitment. Here
                                                are the kinds of headings you
                                                might use:</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">For each DEVELOPMENT GOAL you
                                                    should document:
                                                </div>
                                                <p><span className="subtitle-table"> Actions:</span><br/>
                                                    The various actions needed to achieve the development goal.
                                                </p>
                                                <p><span className="subtitle-table">Timescales: </span><br/>
                                                    A clear timescale for achieving the development actions.
                                                </p>
                                                <p><span
                                                    className="subtitle-table"> Potential barriers:</span><br/>
                                                    Any barriers that prevent the development goals being
                                                    achieved; for example, time,
                                                    budget constraints.
                                                </p>
                                                <p><span className="subtitle-table"> Overcoming barriers:</span><br/>
                                                    Actions to address potential barriers.
                                                </p>
                                                <div className="uiheading"><p><span
                                                    className="subtitle-table"> Resources:</span><br/>
                                                    Any resources; for example, time, money, people and
                                                    equipment needed to achieve
                                                    the goals.
                                                </p></div>
                                            </div>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport">
                                                <tbody>
                                                <tr align="center">
                                                    <th width="25%" align="left" valign="top"
                                                        className="green_curve ">Development Goal:
                                                    </th>
                                                    <th width="37%" align="left" valign="top"
                                                        className="centerCont">1
                                                    </th>
                                                    <th width="37%" align="left" valign="top"
                                                        className=" green_curve1 centerCont">2
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="25%" align="left" valign="middle"
                                                        className="lightgreen">
                                                        <div align="textAlignTable">Actions</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Actions1"
                                                                  value={pageData?.Actions?.Actions1}
                                                                  onChange={this.props.handleChangePageData('Actions')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Actions2"
                                                                  value={pageData?.Actions?.Actions2}
                                                                  onChange={this.props.handleChangePageData('Actions')}/>
                                                    </td>
                                                </tr>
                                                <tr bgcolor="#feefd4">
                                                    <td width="25%" align="left" valign="middle"
                                                        className="darkgreen">
                                                        <div align="textAlignTable">Timescales</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Timescales1"
                                                                  value={pageData?.Timescales?.Timescales1}
                                                                  onChange={this.props.handleChangePageData('Timescales')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Timescales2"
                                                                  value={pageData?.Timescales?.Timescales2}
                                                                  onChange={this.props.handleChangePageData('Timescales')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" align="left" valign="middle"
                                                        className="lightgreen">
                                                        <div align="textAlignTable">Barriers</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Barriers1"
                                                                  value={pageData?.Barriers?.Barriers1}
                                                                  onChange={this.props.handleChangePageData('Barriers')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Barriers2"
                                                                  value={pageData?.Barriers?.Barriers2}
                                                                  onChange={this.props.handleChangePageData('Barriers')}/>
                                                    </td>
                                                </tr>
                                                <tr bgcolor="#feefd4">
                                                    <td width="25%" align="left" valign="middle"
                                                        className="darkgreen">
                                                        <div align="textAlignTable">Overcoming Barriers</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="OvercomingBarriers1"
                                                                  value={pageData?.OvercomingBarriers?.OvercomingBarriers1}
                                                                  onChange={this.props.handleChangePageData('OvercomingBarriers')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="OvercomingBarriers2"
                                                                  value={pageData?.OvercomingBarriers?.OvercomingBarriers2}
                                                                  onChange={this.props.handleChangePageData('OvercomingBarriers')}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" align="left" valign="middle"
                                                        className="lightgreen">
                                                        <div align="textAlignTable">Resources</div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Resources1"
                                                                  value={pageData?.Resources?.Resources1}
                                                                  onChange={this.props.handleChangePageData('Resources')}/>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea rows="3"
                                                                  className="textareaborder"
                                                                  cols="45"
                                                                  name="Resources2"
                                                                  value={pageData?.Resources?.Resources2}
                                                                  onChange={this.props.handleChangePageData('Resources')}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn"><a
                                                onClick={this.props.handleChangePage('Page7')}
                                                className="button">&lt;&lt; Previous </a></div>
                                            <div className="right-btn"><a
                                                onClick={this.props.savePageData('Page9')}
                                                className="button">Next &gt;&gt;</a></div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}